module.exports = __webpack_public_path__ + "media/images/map/payment4-967c5255c26ecc05e533b8a9a96ae6e5.svg";